// Live per-stream meter values (high-frequency socket updates), kept apart
// from stream metadata so cards re-render only their meter badges.
import { HEATING_UP_VELOCITY } from '@/etc/liveMeters'

const pick = (src) => ({
  meters: src.meters || {},
  velocity: src.velocity || {},
  categories: src.categories || {},
  categoryVelocity: src.categoryVelocity || {},
  chat: src.chat || null,
  liveEdgeTimestamp: src.liveEdgeTimestamp ?? null,
})

export default {
  namespaced: true,
  state: {
    byStream: {},
  },
  getters: {
    forStream: (state) => (streamId) => state.byStream[streamId] || null,
    // Top categories for a stream, strongest first.
    dominant: (state) => (streamId, limit = 2) => {
      const cats = state.byStream[streamId]?.categories || {}
      return Object.entries(cats)
        .sort((a, b) => b[1] - a[1])
        .slice(0, limit)
        .filter(([, v]) => v > 0)
    },
    heatingUp: (state) => (streamId) => {
      const vel = state.byStream[streamId]?.categoryVelocity || {}
      return Object.values(vel).some((v) => v >= HEATING_UP_VELOCITY)
    },
  },
  mutations: {
    set: (state, { streamId, values }) => {
      state.byStream = { ...state.byStream, [streamId]: { ...values, updatedAt: Date.now() } }
    },
  },
  actions: {
    fromStream: (store, stream) => {
      if (!stream?.streamId) return
      store.commit('set', { streamId: stream.streamId, values: pick(stream) })
    },
    update: (store, event) => {
      if (!event?.streamId) return
      store.commit('set', { streamId: event.streamId, values: pick(event) })
    },
  },
}
